import { render } from "./CustomsEntryForm.vue?vue&type=template&id=d0d91f44&scoped=true"
import script from "./CustomsEntryForm.vue?vue&type=script&lang=js"
export * from "./CustomsEntryForm.vue?vue&type=script&lang=js"

import "./CustomsEntryForm.vue?vue&type=style&index=0&id=d0d91f44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0d91f44"]])

export default __exports__